export default [
  {
    name: 'orderManagement',
    label: 'labels.orderManagement',
    permissionKey: 'order_management',
    children: [
      {
        name: 'order_add',
        label: 'labels.orderAdd',
        permissionKey: 'order_add'
      },
      {
        name: 'order_edit',
        label: 'labels.orderEdit',
        permissionKey: 'order_edit'
      },
      {
        name: 'order_delete',
        label: 'labels.orderDelete',
        permissionKey: 'order_delete'
      },
      {
        name: 'order_archive',
        label: 'labels.orderArchive',
        permissionKey: 'order_archive'
      },
      {
        name: 'order_activity',
        label: 'labels.viewOrderActivity',
        permissionKey: 'order_activity'
      },
      {
        name: 'order_pricing_view',
        label: 'labels.viewOrderPrices',
        permissionKey: 'order_pricing_view'
      },
      {
        name: 'order_allotment',
        label: 'labels.allotmentOrder',
        permissionKey: 'order_allotment',
        children: [
          {
            name: 'order_allotment_add',
            label: 'labels.allotmentOrderAdd',
            permissionKey: 'order_allotment_add'
          }
        ]
      },

      {
        name: 'orderDocumentManagement',
        label: 'labels.orderDocumentManagement',
        permissionKey: 'order_document_management',
        children: [
          {
            name: 'order_document_add',
            label: 'labels.orderDocumentAdd',
            permissionKey: 'order_document_add'
          },
          {
            name: 'order_document_edit',
            label: 'labels.orderDocumentEdit',
            permissionKey: 'order_document_edit'
          },
          {
            name: 'order_document_delete',
            label: 'labels.orderDocumentDelete',
            permissionKey: 'order_document_delete'
          },
          {
            name: 'order_document_archive',
            label: 'labels.orderDocumentArchive',
            permissionKey: 'order_document_archive'
          }
        ]
      }
    ]
  }

  // {
  //   name: 'orderRequestManagement',
  //   label: 'labels.orderModule.orderRequestManagement',
  //   permissionKey: 'order_request_management',
  //   children: [
  //     {
  //       name: 'order_request_add',
  //       label: 'labels.orderModule.orderRequestAdd',
  //       permissionKey: 'order_request_add'
  //     },
  //     {
  //       name: 'order_request_edit',
  //       label: 'labels.orderModule.orderRequestEdit',
  //       permissionKey: 'order_request_edit'
  //     },
  //     {
  //       name: 'order_request_delete',
  //       label: 'labels.orderModule.orderRequestDelete',
  //       permissionKey: 'order_request_delete'
  //     },
  //     {
  //       name: 'order_request_history_management',
  //       label: 'labels.orderModule.orderRequestHistoryManagement',
  //       permissionKey: 'order_request_history_management'
  //     }
  //   ]
  // }
]
